import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

export default new Router({
  routes,
  linkExactActiveClass: 'is-active'
})



// WEBPACK FOOTER //
// ./src/router/index.js